export default __webpack_public_path__ + "static/media/propmanag3.05f09f40.jpg";